import { AnyAction, createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CommissionLedgerResponse {
  page?: number;
  page_size?: number;
  total?: number;
  data?: AnyAction[];
  summary?: {
    label: string;
    value: number;
  }[];
  policy_type?: string;
  premium_ranges?: {
    id: string;
    label: string;
    from: number | null;
    to: number | null;
  }[];
  products?: {
    lob?: {
      id?: string;
      name?: string;
    };
    commissions?: Record<string, number | null>;
  }[];
}

type CommissionFilterOption = {
  id: string | number;
  label: string;
  name?: string;
};

const normalizeFilterOption = (item: any): CommissionFilterOption | null => {
  if (!item || item.id === undefined || item.id === null) return null;

  const label =
    typeof item.label === "string" && item.label.trim()
      ? item.label
      : typeof item.name === "string" && item.name.trim()
        ? item.name
        : String(item.id);

  return {
    id: item.id,
    label,
    name: label,
  };
};

const toFilterOptions = (payload: any, key?: "insurers" | "countries" | "date_ranges") => {
  const source = Array.isArray(payload)
    ? payload
    : Array.isArray(payload?.data)
      ? payload.data
      : Array.isArray(payload?.filters?.[key || ""])
        ? payload.filters[key || ""]
        : Array.isArray(payload?.[key || ""])
          ? payload[key || ""]
          : [];

  return source
    .map((item: any) => normalizeFilterOption(item))
    .filter((item: CommissionFilterOption | null): item is CommissionFilterOption => item !== null);
};

interface CommissionLedgerState {
  commissionRecords: CommissionLedgerResponse;
  statuses?: CommissionFilterOption[];
  insurers?: CommissionFilterOption[];
  countries?: CommissionFilterOption[];
  dateRanges?: CommissionFilterOption[];
}

const initialState: CommissionLedgerState = {
  commissionRecords: {
    page: 1,
    page_size: 10,
    total: 0,
    data: [],
  },
  statuses: [],
  insurers: [],
  countries: [],
  dateRanges: [],
};

const commissionSlice = createSlice({
  name: "commission",
  initialState,
  reducers: {
    setCommissionRecords: (state, action: PayloadAction<CommissionLedgerResponse>) => {
      console.log("commission records:", action.payload);
      state.commissionRecords = action.payload;
    },
    setCommissionLedgerRecords: (state, action: PayloadAction<CommissionLedgerResponse>) => {
      console.log("commission ledger records:", action.payload);
      state.commissionRecords = action.payload;
    },
    // setCommissionStatuses: (state, action: PayloadAction<any>) => {
    //   state.statuses = toFilterOptions(action.payload, "statuses");
    // },
    setCommissionInsurer: (state, action: PayloadAction<any>) => {
      state.insurers = toFilterOptions(action.payload, "insurers");
    },
    setCommissionInsured: (state, action: PayloadAction<any>) => {
      state.insurers = toFilterOptions(action.payload, "insurers");
    },
    setCommissionCountry: (state, action: PayloadAction<any>) => {
      state.countries = toFilterOptions(action.payload, "countries");
    },
    setCommissionLedgerDateRange: (state, action: PayloadAction<any>) => {
      state.dateRanges = toFilterOptions(action.payload, "date_ranges");
    },
  },
});

export const {
  setCommissionRecords,
  setCommissionLedgerRecords,
  // setCommissionStatuses,
  setCommissionInsurer,
  setCommissionInsured,
  setCommissionCountry,
  setCommissionLedgerDateRange,
} = commissionSlice.actions;
export const { reducer: commissionReducer } = commissionSlice;
